import * as React from 'react'
import { ActivityModel } from '@/modules/drivers/types/activities'
import { BreakModel } from '@/app/models/breakModel'
import { PlaceModel } from '@/app/models/placeModel'
import { CardInsertModel } from '@/app/models/cardInsertModel'
import { DayActivityModel } from '@/app/models/dayActivityModel'
import { NightWorkActivityModel } from '@/app/models/nightWorkActivityModel'
import { ViolationModel } from '@/app/models'
import { DailyRestEventModel } from '@/app/models/dailyRestEventModel'
import { DailyPartialRegularRestEventModel } from '@/app/models/dailyPartialRegularRestModel'
import { WeeklyRestEventModel } from '@/app/models/weeklyRestModel'
import { WeeklyReducedRestEventModel } from '@/app/models/weeklyRegularRestModel'
import { PartialBreakModel } from '@/app/models/partialBreakModel'
import { WeekRecompenseModel } from '@/app/models/weekRecompenseModel'
import { OutOfScopeModel } from '@/app/models/outOfScopeModel'
import { TmsDataModel } from '@/app/models/tmsDataModel'
import { MinimalPaymentCountryModel } from '@/app/models/minimalPaymentCountryModel'
import { ExistingDelegationModel } from '@/app/models/existingDelegationModel'
import { EventModel } from '@/app/models/newDelegation/eventModel'
import { PeriodSelection } from '@/app/models/periodSelection'
import { CountryModel } from '@/modules/shared/types/country'
import { BaseEventModel } from '@/app/models/baseEventModel'

export type TimelineData = {
  activities: ReadonlyArray<ActivityModel>
  vehicleSourceActivities?: ReadonlyArray<ActivityModel>
  breaks: ReadonlyArray<BreakModel>
  places: ReadonlyArray<PlaceModel>
  cardInserts: ReadonlyArray<CardInsertModel>
  dayActivities: ReadonlyArray<DayActivityModel>
  nightWorkActivities: ReadonlyArray<NightWorkActivityModel>
  violations: ReadonlyArray<ViolationModel>
  dailyRests: ReadonlyArray<DailyRestEventModel>
  dailyPartialRegularRests: ReadonlyArray<DailyPartialRegularRestEventModel>
  weeklyRests: ReadonlyArray<WeeklyRestEventModel>
  weeklyReducedRests: ReadonlyArray<WeeklyReducedRestEventModel>
  partialBreaks: ReadonlyArray<PartialBreakModel>
  weekRecompenses: ReadonlyArray<WeekRecompenseModel>
  outOfScopes: ReadonlyArray<OutOfScopeModel>
  tmsData: ReadonlyArray<TmsDataModel>
  minimalPaymentCountries: ReadonlyArray<MinimalPaymentCountryModel>
  changeAreas: ReadonlyArray<BaseEventModel>
  existingDelegations: ReadonlyArray<ExistingDelegationModel>
  periodSelections: ReadonlyArray<PeriodSelection>

  delegationMarkers: ReadonlyArray<EventModel>
  allTripEvents: ReadonlyArray<EventModel>
  allPreviousTripEvents: ReadonlyArray<EventModel>
  allEvents: ReadonlyArray<EventModel>
  countries: ReadonlyArray<CountryModel>

  selectedActivity?: ActivityModel
  editedActivity?: ActivityModel | null
  isAddingNew: boolean
  currentDate?: any
}

const DataContext = React.createContext<TimelineData | null>(null)

export const DataProvider = DataContext.Provider

export const useTimelineData = (): TimelineData => {
  const data = React.useContext(DataContext)
  if (!data) {
    throw new Error('useTimelineData must be used inside <DataProvider>')
  }
  return data
}

export function useLayerData<T>(select: (data: TimelineData) => T): T {
  return select(useTimelineData())
}
